<template>
  <div class="card-light" :class="{ disable: isDisconnect }">
    <vs-row vs-type="flex" vs-align="center">
      <!-- <h7 v-if="switch1 === true">ON</h7>
      <h7 style="color: #989898" v-else>OFF</h7> -->
      <h7 :style="'color :' + colorText">F.{{ device_id.slice(6) }}</h7>
      <vs-spacer></vs-spacer>
      <div>
        <vs-switch
          v-model="switch1"
          color="#007bff"
          class="switch"
          :disabled="isDisonnect"
        >
          <span slot="on">On</span>
          <span slot="off">Off</span>
        </vs-switch>
        <vs-popup
          class="holamundo"
          title="Breaker trun off"
          :active.sync="BreakerPopupActivo"
        >
          <div class="popup-breaker">
            <h1>Are You Sure?</h1>
            <div class="layout-btn">
              <vs-button
                color="danger"
                type="filled"
                @click="BreakerPopupActivo = false"
                >NO</vs-button
              >
              <vs-button color="success" type="filled" @click="confrimOfflight"
                >YES</vs-button
              >
            </div>
          </div>
        </vs-popup>
      </div>
    </vs-row>
    <!-- <br /> -->
    <div class="text-icon">
      <vs-icon icon="wb_incandescent" size="30px" :color="color" />
      <h5 :style="'color :' + colorText">Light</h5>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    device_id: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    color: function () {
      return this.switch1 == true ? "#007bff" : "#EFEFEF";
    },
    colorText: function () {
      return this.switch1 == true ? "#000" : "#989898";
    },
  },
  data() {
    return {
      switch1: true,
      isDisconnect: false,
      interval: null,

      BreakerPopupActivo: false,
    };
  },
  async mounted() {
    // await this.getStatus();
    // if (this.interval != null) {
    //   clearInterval(this.interval);
    // }
    // this.interval = setInterval(async () => {
    //   await this.getStatus();
    // }, 20 * 1000);
    // await this.callData()
  },
  beforeDestroy() {
    console.log("beforeDestroy");
    clearTimeout(this.interval);
  },
  methods: {
    async callData() {
      await this.getStatus();
      this.interval = setTimeout(async () => {
        await this.callData();
      }, 20 * 1000);
    },
    async getStatus() {
      let res = await this.$API.get("tuya/breaker/status/" + this.device_id);
      console.log(this.device_id, res);
      if (res.status === 200 && res.data.success == true) {
        this.switch1 = res.data.result[0].value;
        this.isDisconnect = !res.data.success;
      } else {
        this.isDisconnect = true;
      }
    },
    async onlight() {
      console.log(this.switch1);
      this.switch1 = !this.switch1;
      let body = {
          device: this.device_id,
          value: this.switch1,
        };
        console.log(body);
        // call close breaker
        // let res = await this.$API.post("tuya/breaker/command", body);
        // console.log(res);
        // if (res.status === 200) {
        //   if (res.data.success != true) {
        //     this.switch1 = !this.switch1;
        //   }
        // }
      // if (this.switch1) {
      //   this.BreakerPopupActivo = true;
      // } else {
      //   // call open breaker
      //   this.switch1 = true;
      // }
      // console.log("clock");
    },
    async confrimOfflight() {
      this.switch1 = false;
      // call close breaker
      this.BreakerPopupActivo = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-light {
  border: #007bff 1px solid;
  border-radius: 20px;
  padding: 10px;
  // margin: 0 10px 10px 0;
  background-color: #ffffff;
  width: 110px;
  height: 110px;
  .text-icon {
    text-align: center;
    margin-top: 10px;
  }
}
.switch {
  pointer-events: none;
}
.disable {
  pointer-events: none;
  background-color: #7c7c7c8c;
}
.popup-breaker {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  .layout-btn {
    display: flex;
    gap: 20px;
  }
}
</style>